import React from 'react';
import style from './turnkey.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TurnkeyLanding(props) {

  //Set the window size state to maintain media queries
  const [gridSize, setGridSize] = useState(0)
  
  useEffect (() => {
		const handleGridResize = () => {
      let limit = 0
			if (props.windowSize === "Web") {
        //set column limit
        limit = 4
      } else if (props.windowSize === "Tablet") {
          //set column limit
          limit = 3
      } else {
        //set column limit
        limit = 7
      }

			if (limit !== gridSize) {
				setGridSize(limit)
			}
		}
		
		window.addEventListener('resize', handleGridResize)

		handleGridResize()

		return () => {
			window.removeEventListener('resize', handleGridResize)
		}
  }) 

  let mainPath = '/e2-engineering-services/turnkey-installation-upgrades/'
  let linkArr = [
    'Excitation System Upgrades',
    'Hydro Turbine Generator Control Systems',
    'Sync Motor and Condenser Control Systems',
    'E2HMI',
    'Medium Voltage Switchgear Systems',
    'Protection Systems',
    'Power System Stabilizers'
  ]

  //Handles css grid layout for IE
  let linkElements = []
  let colCount = 1
  let rowCount = 1
  let linkCount = 0

  for (let i = 0; i < linkArr.length; i++) {
    if (props.windowSize !== "Mobile") {
      let classStr = ``

      //Add a right border to every cell that is not the last column in a row
      if (((linkCount + 1) % gridSize) !== 0) {
        classStr += ` ${style.borderRight}`
      }

      //Add a bottom border to every cell that is not in the last row
      if (rowCount <= ((Math.floor(linkArr.length / gridSize) + 1) - 1)) {
        classStr += ` ${style.borderBottom}`
      } 

      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a className={classStr} style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    } else {
      //Create quick link element
      linkElements[linkCount] = <Link key={"link" + linkCount} href={mainPath + linkArr[linkCount].replace(/\s/g, "-").toLowerCase()}><a style={{msGridRow: rowCount, msGridColumn: colCount}}><span>{linkArr[linkCount]}</span></a></Link>
    }  

    //Check if column gridSize has been reached
    if (colCount === gridSize) {
      colCount = 1
      rowCount++
    } else {
      colCount++
    }

    linkCount++
  }

  //Handles style grid by creating the circle elements and changing the columns/rows accordingly (Tablet and Web only)
  let circles = null
  let styleBox1 = null
  let styleBox2 = null
  let styleGrid = null
  let limit = 0

  if (props.windowSize !== "Mobile") {
    limit = 9
    colCount = 1
    rowCount = 1
    circles = []

    for (let x = 0; x < (7 * 9); x++) {

      //Creating accent circle
      circles[x] = <span key={"span" + x} style={{msGridRow: rowCount, msGridColumn: colCount}}></span>

      if (colCount === limit) {
        colCount = 1
        rowCount++
      } else {
        colCount++
      }
    }

    styleBox1 = <div className={style.styleBoxOne}></div>
    styleBox2 = <div className={style.styleBoxTwo}></div>
    styleGrid = <div className={style.styleGrid}>{circles}</div>
  }

  return (
    <div className={style.TurnkeyLanding}>
      <Head>
        <title>Turnkey Installation Upgrades | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> E&#178; Engineering Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>Turnkey Installation Upgrades</h3>
      <div className={style.quickLinkContainer}>
        {styleBox1}
        {styleBox2}
        {styleGrid}  
        <div className={style.quickLinks}>
          {linkElements}
        </div>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[0]}</h4>
        <p>Our engineering experts have extensive experience working with the major original equipment manufacturers (OEMs) as well as hands-on experience with the upfront system design and system startup on most of the original static excitation systems installed in the 1960s-1990s. Some of these systems include the GE Frame 5/6/7/9, the Westinghouse W251/W501 and the GE LM2500/LM5000 units.</p>
        <Link href={mainPath + linkArr[0].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[1]}</h4>
        <p>Hydro generators need to have controls that correctly sense pressure in the penstock pipe leading from the dam to the inlet valves of the hydro turbines. The rotating frequency of the generator, voltage level and VAR flow conditions keep the equipment operating.</p>
        <p>Correct setting of acceleration, deceleration, voltage level, lubrication quantities, and cooling are all required to ensure continued production of power from this flowing water.</p>
        <Link href={mainPath + linkArr[1].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[2]}</h4>
        <p>Our engineers understand the specific requirements associated with synchronous motor control and will develop a complete synchronous motor controller system that includes equipment required to safely accelerate the motor and apply the DC voltage to the rotating field at the correct time. This will insure rapid synchronization while protecting the motor from overload, jam, pull-out and off-frequency conditions.</p>
        <Link href={mainPath + linkArr[2].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[3]}</h4>
        <p>Basler Services&#39; engineers will custom design a Human Machine Interface, or HMI, to provide complete operator functionality specific to your system. Basler Services provides all devices, software and materials required for the installation, interconnection and testing of the E2HMI and associated devices.</p>
        <Link href={mainPath + linkArr[3].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[4]}</h4>
        <p>Our engineers have extensive experience working for the major OEMs and hands-on experience with the upfront system design and system startup on most all of the original voltage systems as installed in the 1960s-1990s. Some of these systems include those provided with the GE and Westinghouse medium & large steam turbines and gas/combustion turbines such as the GE frame 5/6/7/9, the Westinghouse W251/W501 and the GE LM2500/LM5000 units.</p>
        <Link href={mainPath + linkArr[4].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[5]}</h4>
        <p>From servicing electromechanical relay systems to installing new protection modules, Basler Services, LLC has the experience to identify the equipment best suited to meet your needs. There are many advantages to upgrading your system protection, such as better system protection flexibility as well as LCD displays with real-time system monitoring.</p>
        <Link href={mainPath + linkArr[5].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
      <div className={style.quickInfoSection}>
        <h4>{linkArr[6]}</h4>
        <p>Power System Stabilizers can modulate the synchronous machine&#39;s voltage to instantaneously take power from the system or put power into the system by varying the angle between magnetic moment or the rotating field and the rotating magnetic field of the three phase electric system reflected in the voltage on the stationary part of the synchronous machine. If the adjustments of the PSS are set correctly, then power swings into or out of the synchronous machine will act to dampen the system-wide resonant power swings and improve system stability.</p>
        <Link href={mainPath + linkArr[6].replace(/\s/g, "-").toLowerCase()}><a className={`${style.cta} ${style.primaryCta}`}>Learn More <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
      </div>
    </div>
  );
}

export default TurnkeyLanding;